import { action, observable, runInAction } from "mobx";
import { IAgtFilterable } from "./agt.list.filter.ui.store";

export class BaseUiStore<T> {



    name: string = 'PleaseDefineOtherWiseThisWillNotWorkOnProd';

    @observable
    items: T[] = [];



    datenStand?: number; // bm

    loadingPromise?: Promise<any>;
    loadingPromiseResolver?: any;

    // Cache for preventing duplicate function calls
    private functionCache: Map<string, Promise<any>> = new Map();
    private cacheResults: Map<string, any> = new Map();

    initLoadinPromise() {
        this.loadingPromise = new Promise((resolve) => {
            this.loadingPromiseResolver = resolve;
        });
    }


    async _baseLoad() {
        console.log('PLEASE OVERRIDE ME!!');
    }

    async load() {
        if (this.loadingPromise) {
            await this.loadingPromise;
            return;
        }
        if (this.items.length > 0) {
            return;
        }
        // console.log('starting load' + this.name);
        console.time("LOAD " + this.name);

        this.initLoadinPromise();
        await this._baseLoad();
        if (this.loadingPromiseResolver) {
            this.loadingPromiseResolver();
        }
        console.timeEnd("LOAD " + this.name);
    };

    clearCache() {
        this.loadingPromise = undefined;
        this.loadingPromiseResolver = undefined;
        runInAction(() => {
            this.items = [];
        });
        // Clear function cache as well
        this.functionCache.clear();
        this.cacheResults.clear();
        this.customClearCache();

    }

    customClearCache() {
        // override if needed

    }

    /**
     * Wraps an async function with caching to prevent duplicate calls
     * @param cacheKey - Unique key for this function call
     * @param fn - The async function to execute
     * @param options - Optional configuration for caching behavior
     * @returns Promise with the function result
     */
    async withCache<R>(
        cacheKey: string,
        fn: () => Promise<R>,
        options?: {
            cacheResult?: boolean; // Whether to cache the result (default: false)
            ttl?: number; // Time to live in milliseconds (optional)
            measureTime?: boolean; // Whether to measure execution time (default: false)
        }
    ): Promise<R> {

        // Check if this function is already being executed
        const existingPromise = this.functionCache.get(cacheKey);
        if (existingPromise) {
            // console.log(`[${this.name}] Cache hit for key: ${cacheKey} - returning existing promise`);
            return existingPromise as Promise<R>;
        }


        // Check if we have a cached result and it's still valid
        if (options?.cacheResult && this.cacheResults.has(cacheKey)) {
            const cachedData = this.cacheResults.get(cacheKey);
            if (!cachedData.expires || cachedData.expires > Date.now()) {
                // console.log(`[${this.name}] Returning cached result for key: ${cacheKey}`);
                return Promise.resolve(cachedData.result as R);
            } else {
                // Cache expired, remove it
                this.cacheResults.delete(cacheKey);
            }
        }

        // Start timing here - only for actual execution, not cache hits
        if (options?.measureTime) {
            console.time(this.name + '.' + cacheKey);
        }

        // Execute the function and cache the promise
        // console.log(`[${this.name}] Executing function for cache key: ${cacheKey}`);
        const promise = fn()
            .then(result => {
                if (options?.measureTime) {
                    console.timeEnd(this.name + '.' + cacheKey);
                }
                // Cache the result if requested
                if (options?.cacheResult) {
                    const cacheEntry = {
                        result,
                        expires: options.ttl ? Date.now() + options.ttl : null
                    };
                    this.cacheResults.set(cacheKey, cacheEntry);
                }
                // Remove from active promises cache
                this.functionCache.delete(cacheKey);
                return result;
            })
            .catch(error => {
                if (options?.measureTime) {
                    console.timeEnd(this.name + '.' + cacheKey);
                }
                // Remove from cache on error
                this.functionCache.delete(cacheKey);
                throw error;
            });

        // Store the promise to prevent duplicate calls
        this.functionCache.set(cacheKey, promise);

        return promise;
    }

    /**
     * Invalidate specific cache entries
     * @param cacheKey - The cache key to invalidate, or a pattern with * wildcard
     */
    invalidateCache(cacheKey: string) {
        if (cacheKey.includes('*')) {
            // Pattern matching
            const pattern = new RegExp('^' + cacheKey.replace(/\*/g, '.*') + '$');
            const keysToDelete: string[] = [];

            this.functionCache.forEach((_, key) => {
                if (pattern.test(key)) keysToDelete.push(key);
            });
            this.cacheResults.forEach((_, key) => {
                if (pattern.test(key)) keysToDelete.push(key);
            });

            keysToDelete.forEach(key => {
                this.functionCache.delete(key);
                this.cacheResults.delete(key);
            });

            console.log(`[${this.name}] Invalidated ${keysToDelete.length} cache entries matching pattern: ${cacheKey}`);
        } else {
            // Exact match
            this.functionCache.delete(cacheKey);
            this.cacheResults.delete(cacheKey);
            console.log(`[${this.name}] Invalidated cache for key: ${cacheKey}`);
        }
    }

    /**
     * Check if a function is currently being executed
     * @param cacheKey - The cache key to check
     */
    isLoading(cacheKey: string): boolean {
        return this.functionCache.has(cacheKey);
    }

    findAndSplice(elements: any[], func: (agt: any) => Boolean) {
        const index = elements.findIndex(func);
        let obj;
        if (index !== -1) {
            obj = elements[index];
            if (obj) {
                elements.splice(index, 1);
            }
        }
        return [obj, elements];

    }

    filterAndSplice(elements: any[], func: (agt: any) => Boolean) {
        let index = elements.findIndex(func);
        let successIndex;
        let objs = [];
        let c = 0;
        while (index !== -1) {
            c++;
            const obj = elements[index];
            if (obj) {
                elements.splice(index, 1);
                objs.push(obj)
                successIndex = index - objs.length;
            }
            index = elements.findIndex(func);
        }
        // console.log(successIndex, objs.length, c, elements.length);
        return [objs, elements];

    }

    sortByAgt(items: IAgtFilterable[]) {
        return (items.sort((a, b) => a.agt.agtId - b.agt.agtId)) as T[];
    }
}
